module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "abb"
    }
  }), _vm._v("Abbreviations, Names,"), _c('br'), _vm._v("and Sinhala Terms")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("bowser: water tanker.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Chandrika Bandaranaike Kumaratunga: president of Sri Lanka, 1994–2005.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('em', [_vm._v("daana")]), _vm._v(": almsgiving ceremony offered in commemoration of the dead. Relatives offer a "), _c('em', [_vm._v("daana")]), _vm._v(" after seven days, three months, and one year, and thereafter yearly on each death anniversary.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("DS: Divisional secretariat, administrative unit smaller than a province or district but larger than a village. Also divisional secretary, administrator of a divisional secretariat.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("GN: "), _c('em', [_vm._v("grama niladhari")]), _vm._v(", village administrator, government functionary who serves clusters of about 250 families.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("GoSL: Government of Sri Lanka.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("ISGA: Interim Self Governing Authority, administrative arrangement suggested in 2003 by the LTTE.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("JHU: Jathika Hela Urumaya (National Heritage Party), a political party with a Sinhala Buddhist nationalist philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("JVP: Janatha Vimukthi Peramuna (People’s Liberation Front), a political party with Sinhala Buddhist nationalist philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("karma: concept in several South Asian religions regarding the aftereffects of actions. Merit, which affects life situations in the future, accrues or decreases depending on virtuous or nonvirtuous thoughts and actions.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('em', [_vm._v("kasippu")]), _vm._v(": illicit liquor")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('em', [_vm._v("kuDu")]), _vm._v(": drugs; literally “powder.”")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("LTTE: Liberation Tigers of Tamil Eelam, Tamil militant group (also known as the Tigers) that fought for a separate state in the North and East.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Mahinda Rajapaksa: prime minister of Sri Lanka, 2004–5; president of Sri Lanka, 2005–present.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('em', [_vm._v("Muhuda goDa galanawaa")]), _vm._v(": “The sea is flowing into the land.” The Sinhala explanation for what happened during the tsunami event.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("NGO: nongovernmental organization.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("OIC: (police) officer in charge.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("P-TOMS: Post-Tsunami Operational Management Structure, a “joint mechanism” by which donor aid could be distributed both in the government-controlled South and in the LTTE-controlled North and East of Sri Lanka.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('em', [_vm._v("sil")]), _vm._v(": religious practice observed on full moon (Poya) days.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("SLFP: Sri Lanka Freedom Party, political party of Rajapaksa and Kumaratunga, one of the two major political parties in Sri Lanka. Often seen as central or left-leaning, with a "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("progressivist economic policy. Associated in recent years with hawkish Sinhala Buddhist nationalist parties.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("SLMM: Sri Lanka Monitoring Mission, Scandinavian monitors of Sri Lanka’s 2002 cease-fire agreement between the GoSL and the LTTE.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("SN: "), _c('em', [_vm._v("samurdhi nyamaka")]), _vm._v(", poverty alleviation program worker.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("TNA: Tamil National Alliance, alliance of moderate Tamil parties as well as rebel groups. Often seen as the political wing of the LTTE in the Sri Lankan Parliament.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("TO: technical officer.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Trishaw: a three-wheeled auto-rickshaw. Trishaws have a canvas roof, are open on the sides, and comfortably seat a driver in the front and two passengers in the back.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("UNP: United National Party, one of the two major political parties in Sri Lanka. Often seen as right-leaning, procapitalist, and in recent years pro-peace.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("UPFA, United People’s Freedom Alliance: political alliance of SLFP and smaller parties.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283c293a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 78
// module chunks = 0